var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeColor } from '../types';
import { css } from '@emotion/css';
export function PlayIcon() {
    return (_jsx("svg", __assign({ className: iconStyle, width: "25", height: "27", viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M11.5178 5.96857C11.9212 6.20469 11.9212 6.79499 11.5178 7.03111L1.53353 12.8751C1.13012 13.1112 0.625869 12.816 0.625869 12.3438L0.62587 0.655875C0.62587 0.183635 1.13012 -0.111513 1.53353 0.124606L11.5178 5.96857Z", fill: ThemeColor.lightGray }) })));
}
var iconStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
var templateObject_1;
//# sourceMappingURL=PlayIcon.js.map